module.exports = __webpack_public_path__ + "img/ui-preview-tourism.f684e782.jpg";